export const splitSortValue = (value) =>
  value.replace(/(-asc|-desc)/g, ';$1').split(';-');

export const flatFilters = ({ f, ...restProps }, schema) => {
  const flat = {
    ...restProps,
    ...f,
  };

  if (!schema) {
    return flat;
  }

  Object.keys(flat).forEach((key) => {
    if (!schema[key]) {
      delete flat[key];
    }
  });

  return flat;
};

function isEqual(a, b) {
  if (a === b) {
    return true;
  }

  const atype = typeof a;
  const btype = typeof b;

  if (atype !== btype || !a || !b) {
    return false;
  }

  const aIsArray = Array.isArray(a);
  const bIsArray = Array.isArray(b);
  if (aIsArray || bIsArray) {
    return aIsArray === bIsArray && a.sort().join(',') === b.sort().join(',');
  }

  if (atype === 'object') {
    const akeys = Object.keys(a);

    if (akeys.length !== Object.keys(b).length) {
      return false;
    }

    return akeys.every((key) => a[key] === b[key]);
  }
  return false;
}

export const diffKeys = (objA, objB) => {
  const keys = Object.keys({ ...objA, ...objB });
  return keys.filter((key) => !isEqual(objA[key], objB[key]));
};

export function getDiff(defaultValue, newValue) {
  const result = {};
  const keys = Object.keys({ ...defaultValue, ...newValue });

  keys.forEach((key) => {
    if (!isEqual(defaultValue[key], newValue[key])) {
      result[key] = newValue[key];
    }
  });

  return result;
}

export const hasSearchChanged = (filters, nextFilters) => {
  if (filters === nextFilters || !filters || !nextFilters) {
    return false;
  }

  const keys = diffKeys(filters, nextFilters);
  return keys.length > 0;
};

export const extractRootKeys = (query, extraRootKeys) => {
  const { variableDefinitions } = query.definitions[0];
  const rootKeys = [...(extraRootKeys || [])];
  variableDefinitions.forEach((d) => {
    const name = d.variable.name.value;
    if (!rootKeys.includes(name)) {
      rootKeys.push(name);
    }
  });
  return rootKeys;
};

export const formatVariables = (values, rootKeys) => {
  const result = {};

  if (rootKeys.includes('f')) {
    result.f = {};
  }

  Object.entries(values).forEach(([key, value]) => {
    if (rootKeys.includes(key)) {
      result[key] = value;
    } else if (result.f) {
      result.f[key] = value;
    }
  });

  return result;
};
export function getSkip(total, limit, currentSkip) {
  // if are going over the total, just return currentSkip so taht fetchMore stops
  return currentSkip + limit <= total ? currentSkip + limit : currentSkip;
}
